<template lang="pug">
  .crud
    modal-inventories(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        img(src="@/assets/banner.jpg" width="600")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
          div
            h2 {{ $t('strings.inventories') }}:
            span {{ $t('strings.description', {attribute: $t('strings.inventories')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="inventories")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('inventories.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('inventories.'+ item) + ', desc'")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('inventories.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status'") {{data[indextr][column]}}

          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
    footer-controlla
</template>
<script>
import ModalInventories from '@/components/modals/ModalInventories.vue'
import FooterControlla from '@/components/FooterControlla.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Inventories')

export default {
  name: 'Inventories',
  components: {
    FooterControlla,
    ModalInventories,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    enabledDelete: false,
    columns: [
      'sku',
      'product',
      'quantity',
      'unit_price',
      'unit_measurement'
    ],
    status: [
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        sku: '',
        product: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      includes: '', // Agrega las relaciones separados con coma y sin espacio
      orderBy: ''
    }
  }),
  async created () {
    this.currentPage = this.pagination.currentPage
    this.inventories.length === 0 && await this.getInventories(this.currentPage)
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deleteInventory',
      'deleteInventories',
      'loadInventories',
      'loadCatalog',
      'actionInventory',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    addInventory () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editInventory (inventory, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...inventory }
    },
    async deleteInventoryConfirm (inventory) {
      let t = this
      this.auxDeleteInventory = () => {
        t.deleteInventory(inventory).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.inventory'), attribute: this.$t(inventory.sku) }),
        accept: this.auxDeleteInventory
      })
    },
    async deleteInventoriesConfirm () {
      let t = this
      let inventoriesMany = parseDeleteMany(this.selected, 'sku')
      this.auxDeleteInventory = () => {
        t.deleteInventories(inventoriesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.inventory'), attribute: inventoriesMany.values }),
        accept: this.auxDeleteInventory
      })
    },
    async setActionInventory (record, action) {
      record.id && this.actionInventory({ id: record.id, action })
    },
    async getInventories (page) {
      let t = this
      this.loadInventories({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let inventory = this.inventories.filter(inventory => inventory.id === parseInt(index))[0]
      inventory && this.editInventory(inventory, index)
    },
    async getCatalog () {
      Object.keys(this.inventoriesCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    }
  },
  computed: {
    ...mapGetters([
      'inventories',
      'inventoriesCatalog',
      'pagination',
      'filterParams'
    ]),
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getInventories(currentPage)
    },
    filterParams (filter) {
      filter.length === 0 && (this.filters = {
        where: {
          sku: '',
          product: '',
          param: ''
        },
        whereIn: {
          // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        },
        whereBetween: {
          // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
        },
        betweenDates: {
          // Agrega las columnas que se filtraran entre fechas: created_at: []
        },
        includes: '', // Agrega las relaciones separados con coma y sin espacio
        orderBy: ''
      })
      this.selected = []
      this.currentPage = 1
      filter.length === 0 && this.applyFilter(this.filters)
      this.getInventories(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.crud {
  padding-top: 134px !important;
}
.heading {
  display: block !important;
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
